import { render } from "./DownloadAction.vue?vue&type=template&id=7be57674"
import script from "./DownloadAction.vue?vue&type=script&lang=js"
export * from "./DownloadAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__